import React, {useState} from 'react'
import { HeroContainer, HeroBg, VideoBg, ImgBg, HeroContent, HeroH1, HeroP, HeroBtnWrapper, HeroImg, SocialMediaWrap, SocialIconLink, SocialIcons } from './HeroElements'
import Video from '../../videos/hero.mp4'
import Image from '../../images/landingphoto.JPG'
import logo from '../../images/logo500.png'
import {Button} from '../ButtonElements'
import {FaTwitch, FaInstagram, FaTiktok } from 'react-icons/fa'

const HeroSection = () => {

  const [hover, setHover ] = useState(false)

  const onHover = () => {
    setHover(!hover)
  }



  return (
  
    <HeroContainer>
      <HeroBg>
        <ImgBg src={Image} alt="Bea's Minis Hero Image" />
        <VideoBg autoPlay loop muted src={Video} type='video/mp4' />
      </HeroBg>
      <HeroContent>
        <HeroImg src={logo} alt='Beas Minis Logo'/>
        <HeroH1 className='font-link-BS'>Beas Miniatures</HeroH1>
        <HeroP >hand painted custom minitaures for your next table top roleplaying or wargaming session</HeroP>
        <HeroBtnWrapper>
          <Button to='contact' onMouseEnter={onHover} onMouseLeave={onHover} primary="true" dark="true" className='font-family-Mont' smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        offset={-80}>contact</Button>
          <Button to='gallery' onMouseEnter={onHover} onMouseLeave={onHover} primary="true" dark="true" className='font-family-Mont' smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        offset={-80}>gallery</Button>
        </HeroBtnWrapper>
        <SocialMediaWrap>
                <SocialIcons>
                    <SocialIconLink href="https://www.twitch.tv/beas_miniatures" target="_blank" aria-label="Twitch">
                        <FaTwitch />
                    </SocialIconLink>
                    <SocialIconLink href="https://www.instagram.com/beas_miniatures/" target="_blank" aria-label="Instagram">
                        <FaInstagram />
                    </SocialIconLink>
                    <SocialIconLink href="https://www.tiktok.com/@pirateking920" target="_blank" aria-label="Tik-Tok">
                        <FaTiktok />
                    </SocialIconLink>
                </SocialIcons>
            </SocialMediaWrap>
      </HeroContent>
    </HeroContainer>
  )
}

export default HeroSection
